// helper pomaga wykryć wizyty w turbo-frame 'main' z wykorzystaniem zdarzenia 'turbo:before-fetch-request'
//
// Turbo Frames do not trigger document-level navigation events like turbo:visit, turbo:load, or turbo:render
// because they perform scoped, partial page updates rather than full page visits managed by Turbo Drive.
export function isTurboFrameVisit (turboBeforeFetchEvent, frameId = "main") {
  const headers = turboBeforeFetchEvent.detail.fetchOptions.headers
  const newFrameId = headers["Turbo-Frame"]

  return (
    // don't trigger confirms on prefeching
    headers["X-Sec-Purpose"] !== "prefetch" &&
    // don't trigger on turbo streams
    !headers["Accept"].startsWith("text/vnd.turbo-stream.html") &&
    // OnBeforeFetch only for frames, regular visits use `turbo:before-visit` event
    // Allow loading modals (ex. schema in modal on record_fields edit form)
    // or partial form updates (forms--element_click_btn)
    frameId === newFrameId
  )
}
